export default __webpack_public_path__ + "media/images/onglet-gauche-home-85b6b1d00ace2c4e026ee63b7c937fe4.png";